module.exports = __webpack_public_path__ + "arabesque1.70f961a7f98fc72d33c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme/arabesque1.png
// module id = 636
// module chunks = 1